import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    async getCommunications(clientId, page) {
        let res = await Axios.get(
            `${baseURL}communication/client-communication/${clientId}`,
            {
                params: {
                    page: page,
                    perPage: 20
                }
            }
        );

        return res.data.response;
    },
    async deleteCommunication(id) {
        let res = await Axios.delete(`${baseURL}communication/${id}`);

        if (res.data.response.message.code === 200) {
            return true;
        }
        return false;
    },
    async saveCommunication(params) {
        const res = await Axios.post(`${baseURL}communication`, {
            content: params.content,
            patient_id: params.patient_id,
            client_id: params.client_id,
            business_id: params.business_id,
            date: params.date,
            type: params.type
        });

        if (
            res.data.response &&
            res.data.response.message &&
            res.data.response.message.code === 200
        ) {
            return true; // success
        }

        return false;
    },
    async updateCommunication(id, params) {
        const res = await Axios.put(`${baseURL}communication/${id}`, {
            content: params.content,
            patient_id: params.patient_id,
            client_id: params.client_id,
            contact_id: params.contact_id,
            reference_id: params.reference_id,
            reference_type: params.reference_type,
            appointment_id: params.appointment_id,
            type: params.type,
            with_name: params.with_name,
            contact_type: params.contact_type,
            date: params.date
        });

        if (
            res.data.response &&
            res.data.response.message &&
            res.data.response.message.code === 200
        ) {
            return true; // success
        }

        return false;
    },
    async sendSMS(params) {
        let res = await Axios.post(
            `${baseURL}communication/sms-message`,
            params
        );

        return res.data.response;
    },
    async sendSMSCI(params) {
        // why use CI instead of Barramundi? Need to discuss with back-end team
        // regarding the "from" field. As for now, use CI endpoint to complete the task.
        // const res = await Axios.post(`${baseURL}communication/sms-message`); // <-- barramundi endpoint

        const formData = new FormData();
        formData.append("sender_id", params.sender_id);
        formData.append("rtype", params.rtype);
        formData.append("to_mobile_cc", params.to_mobile_cc);
        formData.append("to_mobile", params.to_mobile);
        formData.append("timestamp", params.timestamp);
        formData.append("module_id", params.module_id);
        formData.append("mobile_cc", params.mobile_cc);
        formData.append("mobile", params.mobile);
        formData.append("message", params.message);
        formData.append("change_mobile", params.change_mobile);

        for (const patientId of params.patient) {
            formData.append("patients[]", patientId);
        }

        const res = await Axios.post(
            `${baseURLci}common/communication/send_sms`,
            formData
        );

        if (res.data.state === 0) {
            return true; // success
        }

        return false;
    },
    async sendEmail(params) {
        const formData = new FormData();
        formData.append("sender_id", params.sender_id);
        formData.append("rtype", params.rtype);
        formData.append("timestamp", params.timestamp);
        formData.append("module_id", params.module_id);
        formData.append("subject", params.subject);
        formData.append("message", params.message);
        if (params.is_system_generated !== undefined) {
            formData.append("is_system_generated", params.is_system_generated);
        }

        for (const patientId of params.patient) {
            formData.append("patients[]", patientId);
        }

        for (const recipientId of params.to) {
            formData.append("to[]", recipientId);
        }

        // For Resend Email
        // set the reference type & reference id
        if (
            params.resent_communication !== undefined &&
            params.communication_id !== undefined
        ) {
            formData.append(
                "resent_communication",
                params.resent_communication
            );
            formData.append("communication_id", params.communication_id);
        }

        const res = await Axios.post(
            `${baseURLci}common/communication/send_email`,
            formData
        );

        if (res.data.state === 0) {
            return true; // success
        }

        return false;
    },
    async getCommunicationTypes() {
        const res = await Axios.get(
            `${baseURL}reference/master-communication-type`
        );

        if (
            res.data.response &&
            res.data.response.message &&
            res.data.response.message.code === 200
        ) {
            return res.data.response.resources;
        }

        return [];
    }
};
